import { parseMessageFromNative } from "src/helpers/common";

export interface ParsedCgmMessage {
  action: string;
  data: Record<string, unknown>;
}

/**
 * Parse a postMessage event from RN into a structured CGM message.
 * Returns null if the payload is invalid or not parseable.
 */
export function parseCgmMessage(event: MessageEvent): ParsedCgmMessage | null {
  const payload = parseMessageFromNative(event.data);
  if (!payload) return null;
  const action = (payload.action || payload.type) as string;
  const data = (payload.data as Record<string, unknown>) ?? {};
  return { action, data };
}
